export default "__VITE_ASSET__8BbK5kDo__"